import { debug } from 'zf-web-infra';
import { Base, Block, Box, useBreakpoint } from 'zf-web-components';
// import { customize } from '@customize';
import { useContext, useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { RootContext } from '@stores';
import { useApp } from '@components';
import { Menu } from '../menu';
import styles from './style.module.less';
import type { ReactElement } from 'react';
import type { SiderProps } from './types';

export function SiderComponent(props: SiderProps): ReactElement | null {
  debug.layout('Sider');

  const { token } = Base.theme.useToken();
  const rootContext = useContext(RootContext);
  const { md } = useBreakpoint();
  const mobileCollapsedRef = useRef(false);

  const { name, logo } = useApp();

  useEffect(() => {
    if (md === false && !mobileCollapsedRef.current) {
      rootContext.shared.setCollapsed(true);
      mobileCollapsedRef.current = true;
      return;
    }

    if (md !== false) {
      mobileCollapsedRef.current = false;
    }
  }, [md, rootContext.shared]);

  useEffect(() => {
    if (md !== false || rootContext.shared.collapsed) {
      return;
    }

    const bodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = bodyOverflow;
    };
  }, [md, rootContext.shared.collapsed]);

  // 固定不显示菜单和头部
  if (rootContext.getIsHideMenuAndHeader() || props.show === false) {
    return null;
  }

  // 小于752px 默认左侧菜单栏隐藏
  if (md === false && rootContext.shared.collapsed) {
    return null;
  }

  const navigateToHome = (): void => {
    window.location.assign('/');
  };

  return (
    <>
      <Block if={md === false && !rootContext.shared.collapsed}>
        <div className={styles.mobileSiderMask} onClick={() => rootContext.shared.setCollapsed(true)} />
      </Block>
      <Base.Layout.Sider
        collapsible
        className={md === false ? styles.mobileSider : undefined}
        collapsed={rootContext.shared.collapsed}
        onCollapse={props.onCollapse}
        style={{ overflow: 'auto', height: '100vh', position: 'relative' }}
        trigger={null}
      >
        <Box className={styles.asideContent}>
          <Box className={styles.aside} onClick={navigateToHome}>
            <img src={logo} className={styles.logo} />
            <Block if={!rootContext.shared.collapsed}>
              <span className={styles.label} style={{ color: token.colorPrimary }}>
                {name}
              </span>
            </Block>
          </Box>
          <Menu />
        </Box>
      </Base.Layout.Sider>
    </>
  );
}

export const Sider = observer(SiderComponent);
